export interface VisualisationBannerCounterFactoryProps {

}

export const visualisationBannerCounterFactory = () => ({
    activityTypes: [],
    image: "",
    unitType: ""
});
